import { render, staticRenderFns } from "./StoreForm.vue?vue&type=template&id=886073bc&scoped=true&"
import script from "./StoreForm.vue?vue&type=script&lang=js&"
export * from "./StoreForm.vue?vue&type=script&lang=js&"
import style0 from "./StoreForm.vue?vue&type=style&index=0&id=886073bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "886073bc",
  null
  
)

export default component.exports